define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var EmployeeModel = /** @class */ (function () {
        function EmployeeModel(data) {
            this.Id = ko.observable(0);
            this.MemberNumber = ko.observable(0);
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.CompanyName = ko.observable();
            this.Email = ko.observable();
            this.Notes = ko.observable();
            this.NotesHtml = ko.observable();
            this.Status = ko.observable();
            this.StatusName = ko.observable();
            this.Positions = ko.observableArray([]);
            this.HireDate = ko.observable();
            this.FireDate = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, EmployeeModel.Mapping, self);
            }
        }
        EmployeeModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new EmployeeModel(options.data);
            },
            HireDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            },
            FireDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return EmployeeModel;
    }());
    return EmployeeModel;
});
//# sourceMappingURL=EmployeeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/EmployeeModel.js
// module id = 94
// module chunks = 2